export const STEP_IDS = Object.freeze({
    VIEW_EVENTS_LIST: 'VIEW_EVENTS_LIST',
    CONVERSION_TYPE_SETUP: 'CONVERSION_TYPE_SETUP',
    CONVERSION_TYPE_CONTENT: 'CONVERSION_TYPE_CONTENT',
    SETUP_URL_EVENT: 'SETUP_URL_EVENT',
    SETUP_CLICKS_EVENT_CATEGORY: 'SETUP_CLICKS_EVENT_CATEGORY',
    SETUP_VALUE: 'SETUP_VALUE',
    REVIEW_EVENTS: 'REVIEW_EVENTS',
    BUTTON_ANALYZER_STEP: 'BUTTON_ANALYZER_STEP',
    BUTTON_CONVERSION_LOCATION_SELECTOR: 'BUTTON_CONVERSION_LOCATION_SELECTOR',
    GLOBAL_BUTTON_SETUP: 'GLOBAL_BUTTON_SETUP',
    SUCCESS_TOAST: 'SUCCESS_TOAST',
});
